import Editor from './Editor'

import './style.scss'

export { Editor }
export default Editor
